/**
 * Throws if mock API is enabled while serving a production build (next start).
 * Skips during `next build` so local builds with mock mode in .env.local still work.
 */
export function assertProductionSafe(): void {
  if (process.env.NEXT_PUBLIC_USE_MOCK_API !== "true") return;

  const isProductionBuild =
    process.env.NEXT_PHASE === "phase-production-build" ||
    process.env.NEXT_PHASE === "phase-export";

  if (process.env.NODE_ENV === "production" && !isProductionBuild) {
    throw new Error(
      "NEXT_PUBLIC_USE_MOCK_API must not be true in production. Disable mock mode before deploying."
    );
  }
}
